const AUTHENTICATION_ERRORS_MESSAGE_REGEXP = /\((401|403)\s+(.+?)\)/;

export const IGNORED_SENTRY_ERRORS = [AUTHENTICATION_ERRORS_MESSAGE_REGEXP];
